var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconButton, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow as TableRowBase, withStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveAltIcon from '@material-ui/icons/Done';
import * as React from 'react';
import { useContext } from 'react';
import { ReadOnly } from './inputs';
export var InlineTable = function (_a) {
    var _b = _a.head, head = _b === void 0 ? undefined : _b, children = _a.children, rest = __rest(_a, ["head", "children"]);
    return rest.noBorders ?
        React.createElement(InlineTableContainer, null,
            React.createElement(InlineTableContent, __assign({ head: head }, rest), children))
        : React.createElement(InlineTableContent, __assign({ head: head }, rest), children);
};
export var InlineTableContainer = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var classes = useInlineTableContainerStyles(rest);
    return (React.createElement(TableContainer, { classes: classes }, children));
};
var useInlineTableContainerStyles = makeStyles({
    root: {
        '& table': {
            marginLeft: 0,
            width: '100%',
        }
    }
});
var InlineTableContent = function (_a) {
    var _b = _a.head, head = _b === void 0 ? undefined : _b, children = _a.children, _c = _a.headerOnly, headerOnly = _c === void 0 ? false : _c, rest = __rest(_a, ["head", "children", "headerOnly"]);
    var classes = useInlineTableContentStyles(rest);
    return (children && children.length) || headerOnly ?
        React.createElement(Table, { classes: classes },
            head &&
                React.createElement(TableHead, null, head),
            React.createElement(TableBody, null, children))
        : React.createElement("div", null);
};
var useInlineTableContentStyles = makeStyles({
    root: {
        '& td': {
            borderBottom: function (props) { return props.noRowBorders ? 0 : 1; }
        }
    }
});
export var TableHeader = withStyles({
    root: {
        backgroundColor: '#F2F6F8',
        '& th': {
            color: '#899095',
            fontFamily: 'Montserrat',
            fontSize: 14,
            textTransform: 'uppercase',
            height: 40,
            paddingTop: 0,
            paddingBottom: 0,
        }
    }
})(TableRowBase);
var cellStyle = {
    color: '#101010',
    fontFamily: 'Montserrat',
    fontSize: 14,
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
};
export var TableTotals = withStyles({
    root: {
        '& td': __assign({}, cellStyle, { fontWeight: 500 })
    },
})(TableRowBase);
export var TableRow = withStyles({
    root: {
        '&:not(.group)': {
            cursor: 'pointer',
        },
        '&:hover:not(.group)': {
            '& button': {
                visibility: 'visible'
            },
            backgroundColor: '#f0f0f0'
        },
        '& button': {
            visibility: 'hidden'
        },
        '& td.small': {
            width: '100px'
        },
        '& td.medium': {
            width: '140px'
        },
        '& td.fit-width': {
            width: '1%',
            whiteSpace: 'nowrap'
        },
        '& td.fit-width-tight': {
            width: '1%',
            whiteSpace: 'nowrap',
            padding: '0px'
        },
        '& td.xlarge': {
            width: '250px'
        },
        '&.dark': {
            '& td': {
                color: '#668AA5',
                backgroundColor: '#F1F5F8',
            }
        },
        '&.green': {
            '& td': {
                color: '#668AA5',
                backgroundColor: '#cfefc2',
            }
        },
        '& td': cellStyle
    },
})(TableRowBase);
export var RowEditActions = function (_a) {
    var onSave = _a.onSave, onCancel = _a.onCancel;
    return React.createElement(TableCell, { className: "fit-width" },
        React.createElement(IconButton, { "aria-label": "Save", size: "small", onClick: onSave },
            React.createElement(SaveAltIcon, null)),
        React.createElement(IconButton, { "aria-label": "Cancel", size: "small", onClick: onCancel },
            React.createElement(CancelIcon, null)));
};
export var RowActions = function (_a) {
    var onEdit = _a.onEdit, onDelete = _a.onDelete;
    var readOnly = useContext(ReadOnly);
    return (React.createElement(TableCell, { className: "fit-width" },
        !readOnly && onEdit &&
            React.createElement(IconButton, { "aria-label": "Edit", size: "small", onClick: onEdit },
                React.createElement(EditIcon, null)),
        !readOnly && onDelete &&
            React.createElement(IconButton, { "aria-label": "Remove", size: "small", onClick: onDelete },
                React.createElement(DeleteIcon, null))));
};
export { TableCell } from '@material-ui/core';
//# sourceMappingURL=table.js.map